exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6dfa76fa!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Menu.vue
// module id = 48
// module chunks = 0